// short UI tones for the scan timers
let ctx = null;

function audioContext() {
  const AudioCtx = window.AudioContext || window.webkitAudioContext;
  if (!AudioCtx) return null;
  if (!ctx) ctx = new AudioCtx();
  // resume if the browser auto-suspended it (e.g. page was backgrounded).
  if (ctx.state === "suspended") ctx.resume();
  return ctx;
}

// play a sine tone: `freq` Hz for `duration` seconds, starting `when` seconds
// from now, with short fades to avoid clicks.
function tone(freq, duration, when = 0, volume = 0.4) {
  const ac = audioContext();
  if (!ac) return;
  const osc = ac.createOscillator();
  const gain = ac.createGain();
  osc.type = "sine";
  osc.frequency.value = freq;
  const t = ac.currentTime + when;
  gain.gain.setValueAtTime(0, t);
  gain.gain.linearRampToValueAtTime(volume, t + 0.01);
  gain.gain.setValueAtTime(volume, t + duration - 0.04);
  gain.gain.linearRampToValueAtTime(0, t + duration);
  osc.connect(gain).connect(ac.destination);
  osc.start(t);
  osc.stop(t + duration);
}

// one short beep per countdown second.
export function playCountdownBeep() {
  tone(880, 0.15);
}

// a distinct rising two-note chime when the scan starts.
export function playStartTone() {
  tone(1175, 0.12);
  tone(1568, 0.3, 0.12);
}

// a short filtered noise burst — the body of the shutter click.
function click(duration, when = 0, volume = 0.5) {
  const ac = audioContext();
  if (!ac) return;
  const samples = Math.max(1, Math.floor(ac.sampleRate * duration));
  const buffer = ac.createBuffer(1, samples, ac.sampleRate);
  const data = buffer.getChannelData(0);
  for (let i = 0; i < samples; i += 1) {
    // white noise, decaying fast so it snaps instead of hisses.
    data[i] = (Math.random() * 2 - 1) * (1 - i / samples) ** 3;
  }
  const source = ac.createBufferSource();
  source.buffer = buffer;
  // drop the low end, which is what makes it sound like a click.
  const filter = ac.createBiquadFilter();
  filter.type = "highpass";
  filter.frequency.value = 1800;
  const gain = ac.createGain();
  gain.gain.value = volume;
  source.connect(filter).connect(gain).connect(ac.destination);
  source.start(ac.currentTime + when);
}

// the camera shutter, played on every captured image: two quick clicks.
export function playShutterClick() {
  click(0.045, 0, 0.5);
  click(0.06, 0.05, 0.35);
}
